module.exports = __webpack_public_path__ + "img/1.7551d9ea.svg";